"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.legacyDashboardsReducers = void 0;
var setLegacyDashboards = function (state, action) {
    state.legacyDashboards = action.payload;
};
exports.legacyDashboardsReducers = {
    setLegacyDashboards: setLegacyDashboards,
};
//# sourceMappingURL=legacyDashboardsReducers.js.map